<template>
  <div>
    <Header />
    <div class="layout-main">
      <slot name="router"></slot>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header";
export default {
  name: "Layout",
  components: {
    Header
  }
};
</script>

<style></style>
